// ── V161: 한국어 · 중국어 이름 나누기 ─────────────────────────────────────────────
// 사장님: "중국인 직원한테 입력을 맡길 거라 중국어로 품목을 입력할 거야. 그럼 한국어 입력이 자동으로 돼야 해"
//         "중국어 입력된 것에 한국어 입력() 하고 중국어도 중복으로 쓰는데 그렇지 않게"
//   '청경채(上海青)' · '청경채 上海青' · '上海青' · '청경채' → { ko, zh }
//   한국어 칸(name)에는 한국어만, 중국어 칸(name_zh)에는 중국어만 들어가게 한다.
export const HANGUL_RE = /[가-힣ㄱ-ㅎㅏ-ㅣ]/;
export const CJK_RE = /[㐀-鿿]/;
export const hasHangul = (s) => HANGUL_RE.test(String(s == null ? '' : s));
export const hasCjk = (s) => CJK_RE.test(String(s == null ? '' : s));
/** 한글 없이 한자만 있는 글 (중국어로만 적은 것) */
export const isZhOnly = (s) => hasCjk(s) && !hasHangul(s);

const tidy = (s) => String(s || '').replace(/\s+/g, ' ').replace(/^[\s,，、·]+|[\s,，、·]+$/g, '').trim();

/**
 * 이름 하나를 한국어 · 중국어로 나눈다. 못 나누면 들어온 쪽만 채운다.
 * @returns {{ ko: string, zh: string }}
 */
export function splitKoZh(input) {
  const raw = String(input == null ? '' : input).replace(/\s+/g, ' ').trim();
  if (!raw) return { ko: '', zh: '' };
  if (!hasCjk(raw)) return { ko: raw, zh: '' };
  if (!hasHangul(raw)) return { ko: '', zh: raw };

  // 괄호: '청경채(上海青)' · '숙주(绿豆芽, 확인 필요)' · '白○ (글씨 확인 필요)'
  const m = raw.match(/^(.*?)\s*[(（]([^()（）]*)[)）]\s*(.*)$/);
  if (m) {
    const outside = tidy(`${m[1]} ${m[3]}`);
    const parts = m[2].split(/[,，、]/).map(tidy).filter(Boolean);
    const zhParts = parts.filter(isZhOnly);
    const koParts = parts.filter(p => !isZhOnly(p));
    if (hasHangul(outside) && !hasCjk(outside) && zhParts.length) {
      return { ko: tidy(outside + (koParts.length ? ` (${koParts.join(', ')})` : '')), zh: zhParts.join(' ') };
    }
    if (isZhOnly(outside) && koParts.length && !zhParts.length) {
      return { ko: koParts.join(', '), zh: outside };
    }
  }
  // 띄어쓰기로: '청경채 上海青' · '다진마늘 顺昌蒜蓉酱 14kg' (숫자·영문은 양쪽에)
  const toks = raw.split(' ');
  const ko = toks.filter(t => !isZhOnly(t)).filter(t => hasHangul(t) || !hasCjk(t));
  const zh = toks.filter(t => isZhOnly(t) || (!hasHangul(t) && !hasCjk(t)));
  const koS = tidy(ko.join(' ')); const zhS = tidy(zh.join(' '));
  return { ko: hasHangul(koS) ? koS : raw, zh: hasCjk(zhS) ? zhS : '' };
}

/** 저장된 품목(입고 줄 등)의 보여줄 이름 — 예전에 '청경채(上海青)'처럼 적은 것도 나눠서 */
export function nameParts(item) {
  const name = String(item?.name || '').trim();
  const zh = String(item?.name_zh || '').trim();
  if (hasHangul(name) && hasCjk(name)) {
    const sp = splitKoZh(name);
    if (sp.ko && sp.zh) return { ko: sp.ko, zh: sp.zh };
  }
  return { ko: name, zh: zh && zh !== name ? zh : (isZhOnly(name) ? '' : zh) };
}
